import React, { useState, useEffect } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import brandTheme from "brandTheme/Theme";
import { useNavigate } from "react-router-dom";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
    minHeight: "calc(100vh - 280px)"
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  verifyButton: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0,
  },
  nextButton3: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0px 40px",
    height: "55px",
    width: "8%",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  text: {
    fontSize: "20px",
    fontWeight: 600,
    color: brandTheme.primaryColor,
    marginTop: "20%",
    textAlign: "center",
  },
}));

const EsignSanctionLetter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const { authToken } = useSelector((state) => state.login.authData);
  const [fileLink, setFileLink] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const pdfSrc = isIOS
    ? `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(fileLink)}`
    : fileLink;
  useEffect(() => {
    let intervalId;

    const fetchStatus = async () => {
      const result = await getUserLoanDetails();

      if (result?.data?.status !== "COMPLETED") {
        intervalId = setInterval(async () => {
          const pollResult = await getUserLoanDetails();
          if (pollResult?.data?.status === "COMPLETED") {
            clearInterval(intervalId);
          }
        }, 5000); // poll every 5 seconds
      }
    };

    fetchStatus();

    return () => {
      if (intervalId) clearInterval(intervalId); // cleanup on unmount
    };
  }, []);

  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_SANCTION_LETTER_ESIGN_API + leadId + "/part-a",
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else if (result?.data?.status === "COMPLETED") {
      setFileLink(result?.data?.fileLink);
    }

    return result;
  };

  const onClickEstamp = async () => {
    navigate("/journey/MandateDetails");
  };
  return (
    <Grid container className={classes.container} style={{overflow:'hidden'}}>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="E-sign"
          button1="Next"
          button1click={onClickEstamp}
          disabled1={!fileLink}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid xs={12} sm={12} md={12} style={{ position: "relative" }}>
            {pdfSrc !== "" ? (
              <iframe
                src={pdfSrc}
                style={{
                  width: "100%",
                  height: "80vh",
                  border: "none",
                  overflow: "auto",
                }}
              />
            ) : (
              <Grid xs={12} sm={12} md={12} className={classes.text}>
                Downloading E-sign Letter
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid item xs={12} sm={12} md={12}>
        <BottomButton
          button1="Next"
          button1click={onClickEstamp}
          disabled1={!fileLink}
        />
      </Grid> */}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default EsignSanctionLetter;
